(function ($) {
  tryItOnFormatterV1 = {
    formatter: $('.try-it-on-formatter-v1'),
    hasSppInitFired: false
  };

  Drupal.behaviors.tryItOnFormatterV1 = {
    get: function (key) {
      return tryItOnFormatterV1[key];
    },

    set: function (key, val) {
      tryItOnFormatterV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);
        var cols = thisFormatter.attr('cols');
        var swatchSize = thisFormatter.attr('data-swatch-size');
        var accent = thisFormatter.find('h2').css('color');
        var shadeItems = thisFormatter.find('.shade-item');
        var swatchNameContainer = thisFormatter.find('.swatch-name');
        var swatchesContainer = thisFormatter.find('.swatches');
        var swatchButtonContainer = thisFormatter.find('.swatch-button');
        var backgroundImage = thisFormatter.find('.try-it-on-image');
        var productCategory = backgroundImage.attr('data-prod-category');
        var outerWrap = thisFormatter.find('.outer-wrap');
        var imageOffset = thisFormatter.data('image-offset');
        var userOffset = 0;
        var outerWrapPadding = 0;
        var imageWidth = 0;

        if (imageOffset && imageOffset.length) {
          var formatterOffset = imageOffset.split(':');

          userOffset = formatterOffset[0];
          if (formatterOffset.length > 1) {
            outerWrapPadding = formatterOffset[1];
            imageWidth = formatterOffset[2];
          }
        }
        var skintoneThumbs = thisFormatter.find('.skintone_thumbs');
        var hasSkinTone = 0;

        if (skintoneThumbs.length > 0) {
          hasSkinTone = 1;
        }

        // build object
        var swatches = [];

        shadeItems.each(function (i) {
          var image = $(this).find('.shade-image').attr('src');
          var color = $(this).find('.shade-box').css('background-color');
          var name = $(this).find('.shade-name').text();
          var button = $(this).find('.shade-button');

          swatches[i] = {
            'swatch': 'swatch-' + i,
            'data': {
              'image': image,
              'color': color,
              'name': name,
              'button': button
            }
          };
        });

        // build swatches grid
        swatchSize = swatchSize ? swatchSize + 'px' : null;
        $.each(swatches, function (i, val) {
          swatchesContainer.append($('<div/>', {
            'class': 'swatch',
            'swatch': val['swatch'],
            'css': {
              'background-color': val['data']['color'],
              'width': swatchSize,
              'height': swatchSize
            }
          }));
        });

        // setup columns
        $('<div class="clear" />').insertAfter(swatchesContainer.find('.swatch:nth-child(' + cols + 'n)'));

        var setHeight = function () {
          var formatterHeight = '100%';

          if (outerWrapPadding != 0 && imageWidth != 0) {
            var outerWrapPaddingBottom = parseInt(outerWrapPadding) + 6;

            outerWrap.css('padding', outerWrapPadding + 'px 0 ' + outerWrapPaddingBottom + 'px');
          }
          backgroundImage.css('height', formatterHeight);
        };

        // when swatch is clicked
        swatchesContainer.find('.swatch').on('click', function(e) {
          var item = $(this).attr('swatch');
          var obj = null;

          $.each(swatches, function (i, val) {
            if (val['swatch'] == item) {
              obj = val['data'];
              if (hasSkinTone == 1) {
                var selectedSkinToneClass = skintoneThumbs.find('.active').attr('class').split(' ')[0];

                obj['image'] = shadeItems.eq(i).find('img.' + selectedSkinToneClass).attr('src');
              }
            }
          });

          // add active class
          swatchesContainer.find('.swatch').removeClass('active');
          $(this).addClass('active');

          // change swatch name
          swatchNameContainer.empty().append(obj['name']);
          // change background image
          backgroundImage.fadeOut(300, function () {
	  backgroundImage.css('background-image', 'url("' + obj['image'] + '")');
            backgroundImage.fadeIn(300);
          });
          // change add to bag button
          var cartButton = obj['button'];

          cartButton.once().on('click', function(e) {
            e.preventDefault();
            // get sku for 'add to cart'
            var buySkus = [];

            buySkus = $(this).attr('data-skubaseid');
            // add sku to cart
            site.addToCart({
              skuBaseId: buySkus
            });
          });

          swatchButtonContainer.empty().append(cartButton);

          // function to get price from current sku, per click (with accomodations for instances in which this is called before the SPP has been initialized)
          var skuBaseId = cartButton.attr('data-skubaseid'),
            product_obj = Drupal.cl.tryGetObject(page_data, 'PRODUCT_ID', $(this).attr('data-productid')),
            prodId = $('.module-spp-detail').attr('data-productid'),
            product = $(product_obj).filter(function () {
              return this.PRODUCT_ID === prodId;
            })[0];

          if (typeof product === 'undefined') {
            return;
          }

          var getPrice = function () {
          // var skuBaseId = cartButton.attr("data-skubaseid"),
          // var matchedSkus = $(site.spp.data.product.skus).filter(function () { // pulled from clinique_product_spp_v1.js
            var matchedSkus = $(product.skus).filter(function () {
                return this.SKU_BASE_ID.toString() === skuBaseId;
              }),
              matchedSku;

            if (matchedSkus) {
              if (matchedSkus.length === 1) {
                matchedSku = matchedSkus[0];
              } else if (matchedSkus.length > 1) {
                throw new Error('Too many skus were matched for this shade, for try-it-on-formatter-v1, in its init process');
              } else {
                throw new Error('No skus were matched for this shade, for try-it-on-formatter-v1, in its init process');
              }
            } else {
              throw new Error('The sku find method failed abnormally, for try-it-on-formatter-v1, in its init process');
            }

            $('.module-spp-detail .options .price')
              .clone()
              .insertBefore(cartButton)
              .find('.formatted_price')
              .text(matchedSku.formattedPrice);
          };

          if (self.get('hasSppInitFired')) {
            getPrice();
          } else {
            $(document).one('site.spp.init.finished', function () { // to make sure that this only fires once, EVEN if the spp.init.finished event fires twice or more
              getPrice();
              setHeight();
              self.set('hasSppInitFired', true);
            });
          }
        });

        // Add to Bag color
        $('.shade-button', context).css('background-color', accent);

        // initialize first swatch
        swatchesContainer.find('.swatch').first().trigger('click');
        setHeight();
        if (hasSkinTone == 1) {
          skintoneThumbs.find('img').on('click', function() {
            skintoneThumbs.find('img').removeClass('active');
            $(this).removeClass('active').addClass('active');
            swatchesContainer.find('.swatch.active').trigger('click');
          });
        }
        $(window).resize(function () {
          var leftPos = outerWrap.offset().left;
          var pos = leftPos + parseInt(userOffset);

          backgroundImage.css('backgroundPosition', pos + 'px top');
        }).resize();
      });
    }
  };
})(jQuery);
